<template>
  <component :is="tag" class="cell-vertical-divider"
    ><div v-bind="$attrs" :class="{ [`${color}-cell-divider`]: true }"></div
  ></component>
</template>
<script>
export default {
  name: "TableVerticalDivider"
};
</script>
<script setup>
defineProps({
  tag: {
    type: String,
    validator(tag) {
      return ["th", "td"].includes(tag);
    },
    default: "td"
  },
  color: {
    type: String,
    default: "black"
  }
});
</script>
<style lang="scss">
.entsys--table,
.fipa-app-table {
  th,
  td {
    &.cell-vertical-divider {
      $cellWidth: 2px;
      padding: 0 6px;
      div {
        margin: auto;
      }

      width: $cellWidth;

      .black-cell-divider {
        width: $cellWidth;
        background: #535353;
      }
      .white-cell-divider {
        width: $cellWidth;
        background: white;
      }
      .grey-cell-divider {
        width: $cellWidth;
        background: #e0dfde;
      }
    }
  }
}
</style>
